import { queryClient } from 'queryClient';
import { type FeatureFlag, MAINTENANCE_MODE } from 'constants/features';
import { queryKeys } from 'hooks/queryKeys';

type Flags = Partial<Record<FeatureFlag, boolean>>;

export const maintenanceMode = {
  enable: () => {
    const payload = queryClient.setQueryData<Flags>(
      queryKeys.flags.by(MAINTENANCE_MODE),
      previous => ({ ...previous, [MAINTENANCE_MODE]: true }),
    );

    return { type: 'MAINTENANCE_MODE_ENABLED', payload };
  },
};
